import { UpdateFavicon } from '@/connection/settings/update-favicon';
import { ProjectStateReducerCreator } from '../types';

const setFaviconReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ project_uuid, favicon }: { project_uuid: string; favicon?: string }) => {
      try {
        const result = await UpdateFavicon(project_uuid, favicon);

        return result;
      } catch (e) {
        console.error(e);
      }
    },
    {
      pending: (state) => {
        if (state.workingProject) {
          state.isSettingsUpdating = true;
        }
      },
      fulfilled: (state, action) => {
        if (state.workingProject && action.payload) {
          state.workingProject.favicon = action.payload?.favicon;
          state.isSettingsUpdating = false;
        }
      },
      rejected: (state) => {
        state.isSettingsUpdating = false;
      },
    }
  );
};

export default setFaviconReducer;
